
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from "vue-property-decorator"

@Component({})
export default class Error extends Vue {
  @Prop({ default: null })
  private errorTextKey!: string;

  @Prop({ default: null })
  private actionTextKey!: string;

  @Prop({ default: null })
  private actionLink!: string;

  @Prop({ default: null })
  private buttonTextKey!: string;
}
